import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {PageBaseSection} from "../../../models/Page/PageBaseSection";
import {RestoreScrollPositionDirective} from "../../../directives/restore-scroll-position.directive";

@Component({
  selector: 'base-section',
  standalone: true,
  imports: [CommonModule, RestoreScrollPositionDirective],
  templateUrl: './base-section.component.html',
  styleUrl: './base-section.component.scss'
})
export class BaseSectionComponent<T extends PageBaseSection> implements OnChanges, OnInit{
  @Input() section : PageBaseSection;
  @Input() index : number;
  sectionRendered : T;

  ngOnInit() {
    if(this.sectionRendered){
      this.sectionRendered.active = true;
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['section'] && changes['section'].isFirstChange()){
      this.sectionRendered = this.section as unknown as T
    }
  }
}
